import tableColumnsBuilder from './table-columns-builder';

export {
  tableColumnsBuilder
}



// WEBPACK FOOTER //
// ./src/browser/components/clients/utils/index.js